import { Statistic } from "antd";
import React, { createContext, useContext } from "react";
import { Observer } from "mobx-react-lite";

import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";

import { ProgressIndicator } from "@fluentui/react";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const TotalGasCard = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <div className="ms-Grid " dir="ltr">
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Observer>
            {() =>
              flowstationPerformanceStore.isLoading ? (
                <div style={{ paddingTop: "25px" }}>
                  <ProgressIndicator
                    label="Loading  total gas dashlet,please wait..."
                    description=""
                  />
                </div>
              ) : (
                <>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "gray",
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    <span>{`@${flowstationPerformanceStore.selMonthName},${flowstationPerformanceStore.selYear}`}</span>
                  </div>
                  <Statistic
                    title={
                      <div style={{ fontSize: "20px", paddingTop: "10px" }}>
                        Total Gas
                      </div>
                    }
                    value={Math.round(
                      Number(flowstationPerformanceStore.totalGas)
                    ).toLocaleString()}
                    suffix={
                      <span
                        style={{ fontSize: "16px", fontFamily: "consolas" }}
                      >
                        mscfd
                      </span>
                    }
                    valueStyle={{
                      fontSize: "30px",
                      color: "limegreen",
                      fontFamily: "consolas",
                    }}
                  />
                  <Statistic
                    title={
                      <div style={{ fontSize: "20px", paddingTop: "10px" }}>
                        &nbsp;
                      </div>
                    }
                    value={Math.round(
                      Number(flowstationPerformanceStore.totalGasBoe)
                    ).toLocaleString()}
                    suffix={
                      <span
                        style={{ fontSize: "16px", fontFamily: "consolas" }}
                      >
                        boepd
                      </span>
                    }
                    valueStyle={{
                      fontSize: "30px",
                      color: "darkgreen",
                      fontFamily: "consolas",
                      marginLeft: "5px",
                    }}
                  />
                </>
              )
            }
          </Observer>
        </div>
      </div>
    </div>
  );
};

